import { Component, Input, forwardRef, ChangeDetectorRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';

import { SelectBaseComponent } from '../select-base';

@Component({
  selector: 'app-cs-select',
  templateUrl: './cs-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CsSelectComponent),
      multi: true
    }
  ]
})
export class CsSelectComponent extends SelectBaseComponent {
  constructor(http: _HttpClient, cdr: ChangeDetectorRef) {
    super(http, cdr);
  }

  @Input() outstandingOnly: boolean = false;

  getUrl(searchValue: string): string {
    let filter = '';
    if (searchValue) {
      const searchStr = searchValue.replaceAll("'", "''");
      filter = `(contains(docCode, '${encodeURIComponent(
        searchStr
      )}') or contains(customerName,'${encodeURIComponent(searchStr)}'))`;
    }
    if (this.outstandingOnly === true) {
      if (filter) {
        filter += `and refundStatus ne 'Fully'`;
      } else {
        filter = `refundStatus ne 'Fully'`;
      }
    }
    let url = `api/cashsales/lookup?$expand=currency($select=code)&$top=20&$skip=0&$orderby=docCode desc`;
    if (filter) url += `&$filter=${filter}`;
    return url;
  }
}
